import { styled, Typography } from '@mui/material';

export const PageHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 24,
  fontFamily: 'Exo, "Open Sans", sans-serif',
  fontWeight: 600,
}));
